import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-equipment-administration',
  templateUrl: './equipment-administration.component.html',
  styleUrls: ['./equipment-administration.component.scss']
})
export class EquipmentAdministrationComponent implements OnInit {
  pt: string = 'pt-70';
  pb: string = 'pb-20'; 
  ptb: string = 'ptb-100'; 
  section: string = 'equipment-administration'; 
  title: string = 'Consulta Nuestros Precios Sin Compromiso, Contáctanos.'; 

  constructor() { }

  ngOnInit(): void {

  }

}
